export default __webpack_public_path__ + "static/media/Strontium.9b034713.svg";